import React, { useState, useEffect, useContext } from "react";
import { message } from "antd";
import { LoadingContext } from "../../../providers/LoadingContext";
import YouTubeVideo from "../../video/YouTubeVideo";
// import VimeoVideo from "../../video/VimeoVideo"; // (still commented out in JSX)

const JumboGrid = (props) => {
  const config = "https://s3.amazonaws.com/www.nocapvote.com";

  const [bannerBottomLeft, setBannerBottomLeft] = useState(null);
  const [bannerTopLeft, setBannerTopLeft] = useState(null);
  const [bannerBottomMid, setBannerBottomMid] = useState(null);
  const [bannerRight, setBannerRight] = useState(null);
  const [bannerTopMid, setBannerTopMid] = useState(null);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const { setGlobalLoading } = useContext(LoadingContext);

  // ✅ Update global loading only when `loading` changes (NOT during render)
  useEffect(() => {
    setGlobalLoading(loading);
  }, [loading, setGlobalLoading]);

  // ✅ Fetch all ads in parallel (Promise.all) instead of sequential awaits
  useEffect(() => {
    let alive = true;

    (async () => {
      setLoading(true);
      setError(null);

      try {
        const [bottomLeft, right, topLeft, bottomMid, topMid] = await Promise.all([
          props.getAd("banner-bottom-left", "home"),
          props.getAd("banner-right", "home"),
          props.getAd("banner-top-left", "home"),
          props.getAd("banner-bottom-mid", "home"),
          props.getAd("banner-top-mid", "home"),
        ]);

        if (!alive) return;

        setBannerBottomLeft(bottomLeft);
        setBannerRight(right);
        setBannerTopLeft(topLeft);
        setBannerBottomMid(bottomMid);
        setBannerTopMid(topMid);
      } catch (e) {
        if (!alive) return;
        setError(e);
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [props.getAd]);

  if (error) {
    message.error(
      "Oops ... Something went wrong, we could not load the information for this search"
    );
    return null;
  }

  return (
    !loading && (
      <div>
        <div className="mobile-view">
          <img
            className="right-mobile"
            alt="placeholder"
            src={`${config}${bannerBottomMid}`}
            loading="lazy"
          />
        </div>

        <div className="JumboGrid">
          <div className="jumbo-container">
            <div className="jumbo-item jumbo-item1">
              <div className="jumbo-image-wrapper">
                <img alt="placeholder" src={`${config}${bannerTopLeft}`} loading="lazy" />
              </div>
            </div>

            {/* <div className="jumbo-item jumbo-item2">
              <div className="jumbo-image-wrapper">
                <img alt="placeholder" src={`${config}${bannerRight}`} />
              </div>
            </div> */}

            <div className="jumbo-item jumbo-item3">
              <div className="jumbo-image-wrapper">
                <img alt="placeholder" src={`${config}${bannerTopMid}`} loading="lazy" />
              </div>
            </div>

            <div className="jumbo-item jumbo-item4">
              <div className="jumbo-image-wrapper">
                <img alt="placeholder" src={`${config}${bannerRight}`} loading="lazy" />
              </div>
              {/* <VimeoVideo /> */}
            </div>

            <div className="jumbo-item jumbo-item5">
              <div className="jumbo-image-wrapper">
                <img alt="placeholder" src={`${config}${bannerBottomLeft}`} loading="lazy" />
              </div>
            </div>

            <div className="jumbo-item jumbo-item6">
              <div className="jumbo-image-wrapper">
                <YouTubeVideo videoId="CPU1P38nTkY" />
              </div>
            </div>

            {/* <div className="jumbo-item jumbo-item7">
              <div className="jumbo-image-wrapper">
                <img alt="placeholder" src={`${config}${bannerBottomLeft}`} />
              </div>
            </div> */}

            <div className="jumbo-item jumbo-item8">
              <div className="jumbo-image-wrapper">
                <img alt="placeholder" src={`${config}${bannerBottomMid}`} loading="lazy" />
              </div>
              {/* <Vio /> */}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default JumboGrid;
